import React, { useEffect, useState } from "react";
import useAuth from "../hooks/useAuth";
import useMatricula from "../hooks/useMatricula";
import useProcesoMatricula from "../hooks/useProcesoMatricula";
import { obtenerLabelEtiqueta } from "../utils/idioma/LabelsIdioma";
import { construirUrlS3 } from "../utils/utils";

const RequisitoMatricula = () => {
  let { setSeleccionPdf } = useProcesoMatricula();
  let { listadoRequisitosMatricula, listadoInforMatriDocumento } =
    useMatricula();

  const { listadoEtiquetas } = useAuth();
  const [etiquetas, setEtiquetas] = useState({});

  useEffect(() => { 
    if (listadoEtiquetas.length > 0) {
      setEtiquetas({
        requisito_matricula: obtenerLabelEtiqueta(
          "lbl_home_requisito_matricula",
          listadoEtiquetas
        ),
        informacion_matricula: obtenerLabelEtiqueta(
          "lbl_home_informacion_matricula",
          listadoEtiquetas
        ),
      });
    }
  }, [listadoEtiquetas]);
  const { requisito_matricula, informacion_matricula } = etiquetas;

  return (
    <div className="card-wrapper ">
      <div className="card shadow-sm w-50">
        <div className="card-body">
          <h6 className="text-uppercase mb-4">{requisito_matricula}</h6>

          <ul
            className=" requirements-list list-group mb-0"
            data-role="tasklist"
          >
            {listadoRequisitosMatricula.map((data) => {
              return (
                <li
                  key={data.crequisito}
                  className="list-group-item border-0 mb-0 py-1 ps-0"
                  data-role="task"
                >
                  <div className="form-check-inline w-100">
                    <input
                      name="cssCheckbox"
                      id="demo_opt_2"
                      type="checkbox"
                      className={
                        data.bcompletado ? "success-checkbox" : "error-checkbox"
                      }
                      checked={true}
                      disabled
                    />
                    <label htmlFor="demo_opt_2"></label>
                    <span className="fs-reg" dangerouslySetInnerHTML={{ __html: data?.drequisito ?? "" }} />
                  </div>
                </li>
              );
            })}
          </ul>
        </div>
      </div>

      <div className="card shadow-sm w-50 ms-4">
        <div className="card-body">
          <h6 className="text-uppercase fs-reg mb-4">
            {informacion_matricula}
          </h6>
          <ul>
            {listadoInforMatriDocumento.map((data) => {
              return (
                <li className="mb-2 d-flex" key={data.cdocumento}>
                  <span className="text-secondary">
                    <i className="fal fa-file-pdf"></i>
                  </span>
                  <button
                    onClick={() => {
                      setSeleccionPdf({
                        ruta: data.url ?? data.druta ?? construirUrlS3(data.bucket_s3, data.key_s3),
                        title:data.tdocumento
                      });
                    }}
                    className="btn p-0 ms-2 text-start"
                    type="button"
                    data-bs-toggle="modal"
                    data-bs-target="#staticBackdrop"
                  >
                    <span className="text-black text-underline mb-0 text-decoration-underline ">
                      {data.tdocumento}
                    </span>
                  </button>
                </li>
              );
            })}
          
          </ul>
        </div>
      </div>
    </div>
  );
};

export default RequisitoMatricula;
